import { render, staticRenderFns } from "./RefreshCourseDataButton.vue?vue&type=template&id=4414adaa&scoped=true&"
import script from "./RefreshCourseDataButton.vue?vue&type=script&lang=js&"
export * from "./RefreshCourseDataButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4414adaa",
  null
  
)

export default component.exports